import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { passwordPolicyValidator } from '../../../shared/validators/input-validators';
import { Apollo } from 'apollo-angular';

import { CITIZEN_VERIFY_OTP_NUMBER } from './set-new-password.graphql';
import { AuthService } from '../../../services/auth.service';
import { NotificationService } from '../../../services/notification.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss'],
})
export class SetNewPasswordComponent implements OnInit {
  title: string;

  hidePassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;

  form!: FormGroup;

  private emailOrPhone: string | null;
  private get isPhone(): boolean {
    return this.emailOrPhone?.startsWith('255') ?? false;
  }

  constructor(
    private fb: FormBuilder,
    private location: Location,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {
    this.emailOrPhone = this.activatedRoute.snapshot.paramMap.get('emailOrPhone');
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      newPassword: [null, [Validators.required, passwordPolicyValidator()]],
      confirmPassword: [null, [Validators.required, passwordPolicyValidator()]],
    });
  }

  submitForm(formValue: { newPassword: string; confirmPassword: string }): void {
    if (formValue.newPassword !== formValue.confirmPassword) {
      this.notificationService.errorMessage('Confirm password does not match.');
      return;
    }
    console.log(this.emailOrPhone)

    this.apollo
      .mutate({
        mutation: CITIZEN_VERIFY_OTP_NUMBER,
        fetchPolicy: 'network-only',
        variables: {
          email: this.isPhone ? null : this.emailOrPhone,
          phoneNumber: this.isPhone ? this.emailOrPhone : null,
          password: formValue.confirmPassword,
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data ?? {})[0];
        result = result?.citizenVerifyOtpNumber;

        if (result?.response.status) {
          this.notificationService
            .successMessage(result.response.message)
            .then(() => this.authService.logout());
        } else {
          this.notificationService.errorMessage(
            `${result?.response?.message} code: ${result?.response?.code}`
          );
        }
      });
  }

  goBack(): void {
    this.location.back();
  }
}
